import { vModelText as _vModelText, mergeProps as _mergeProps, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["placeholder", "maxlength", "name", "disabled"]
const _hoisted_2 = ["disabled", "name"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _mergeProps({..._ctx.$attrs, ..._ctx.$props}, {
    "is-currency": true,
    append: $props.symbol
  }), _createSlots({
    default: _withCtx(() => [
      (!_ctx.readOnly)
        ? _withDirectives((_openBlock(), _createElementBlock("input", _mergeProps({
            key: 0,
            ref: "input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model) = $event)),
            type: "text",
            inputmode: "decimal",
            class: ['gfu-field__input gfu-field__input--text-' + _ctx.textAlign, { 'gfu-field__input--small': _ctx.small }],
            placeholder: _ctx.placeholder,
            maxlength: _ctx.maxlength,
            name: _ctx.name,
            disabled: _ctx.disabled
          }, { min: _ctx.min, max: _ctx.max, step: _ctx.step }, {
            onKeypress: _cache[1] || (_cache[1] = (...args) => (_ctx.onKeyPress && _ctx.onKeyPress(...args))),
            onKeyup: _cache[2] || (_cache[2] = (...args) => (_ctx.onKeyUp && _ctx.onKeyUp(...args))),
            onFocusout: _cache[3] || (_cache[3] = (...args) => (_ctx.onFocusOut && _ctx.onFocusOut(...args))),
            onBlur: _cache[4] || (_cache[4] = (...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
            onKeydown: _cache[5] || (_cache[5] = (...args) => (_ctx.onKeydown && _ctx.onKeydown(...args))),
            onInput: _cache[6] || (_cache[6] = (...args) => (_ctx.handleChange && _ctx.handleChange(...args))),
            "data-qa": "number-field-input"
          }), null, 16 /* FULL_PROPS */, _hoisted_1)), [
            [_vModelText, _ctx.model]
          ])
        : (_ctx.model && _ctx.readOnly)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 1,
              ref: "input",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (($options.formattedValue) = $event)),
              class: _normalizeClass(['gfu-field__input gfu-field__input--readonly', { 'gfu-field__input--small': _ctx.small }]),
              type: "text",
              disabled: _ctx.disabled,
              readonly: "readonly",
              name: _ctx.name,
              "data-qa": "number-field-input"
            }, null, 10 /* CLASS, PROPS */, _hoisted_2)), [
              [_vModelText, $options.formattedValue]
            ])
          : (_openBlock(), _createElementBlock("span", {
              key: 2,
              class: _normalizeClass(['gfu-field__input gfu-field__input--faux gfu-field__input--readonly', { 'gfu-field__input--small': _ctx.small }]),
              "data-qa": "number-field-value"
            }, [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode(_toDisplayString($props.readOnlyPlaceholder), 1 /* TEXT */)
              ])
            ], 2 /* CLASS */))
    ]),
    _: 2 /* DYNAMIC */
  }, [
    (_ctx.$slots.description)
      ? {
          name: "field-description",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "description")
          ]),
          key: "0"
        }
      : undefined
  ]), 1040 /* FULL_PROPS, DYNAMIC_SLOTS */, ["append"]))
}